import { render, staticRenderFns } from "./route-node.vue?vue&type=template&id=470df32e&scoped=true"
import script from "./route-node.vue?vue&type=script&lang=js"
export * from "./route-node.vue?vue&type=script&lang=js"
import style0 from "./route-node.vue?vue&type=style&index=0&id=470df32e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470df32e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('470df32e')) {
      api.createRecord('470df32e', component.options)
    } else {
      api.reload('470df32e', component.options)
    }
    module.hot.accept("./route-node.vue?vue&type=template&id=470df32e&scoped=true", function () {
      api.rerender('470df32e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/main-data/route-node/route-node.vue"
export default component.exports